import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_OurServices = _resolveComponent("OurServices")!
  const _component_CapabilitiesContent = _resolveComponent("CapabilitiesContent")!
  const _component_IncreaseYourBrands = _resolveComponent("IncreaseYourBrands")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    _createVNode(_component_OurServices),
    _createVNode(_component_CapabilitiesContent),
    _createVNode(_component_IncreaseYourBrands, {
      class: "pt-100",
      className: "border-style pb-100"
    }),
    _createVNode(_component_MainFooter)
  ], 64))
}